import React from 'react'
import type { MysterySelection } from '@mobi/betslip/types'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { spacing } from '@mobi/component-library/Foundations'
import { parseMysterySelectionString, getAcceptorsFromMysteryBetLine } from '../helpers'
import { PlaceText } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/BetInfoHeader/Components/Common/PlaceText'
import { SelectionInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SelectionInfo'

interface MysteryNoveltySelectionProps {
  selection: MysterySelection
}

export const MysteryNoveltySelection = ({ selection }: MysteryNoveltySelectionProps) => {
  if (!selection || !selection.bets) {
    return null
  }

  const bet = selection.bets[0]
  const betLine = bet.betLines[0]
  const acceptors = getAcceptorsFromMysteryBetLine(betLine)

  const parsed = parseMysterySelectionString(
    bet.betLines[0].selections,
    selection.isAlways,
    acceptors
  )
  return (
    <Flex flexDirection='column' gap={spacing.smx1}>
      {parsed['1st'] && <SelectionInfo leftSlot={<PlaceText text='1st' />} text={parsed['1st']} />}

      {parsed['2nd'] && <SelectionInfo leftSlot={<PlaceText text='2nd' />} text={parsed['2nd']} />}

      {parsed['3rd'] && <SelectionInfo leftSlot={<PlaceText text='3rd' />} text={parsed['3rd']} />}

      {parsed['4th'] && <SelectionInfo leftSlot={<PlaceText text='4th' />} text={parsed['4th']} />}

      {parsed.ALLWAYS && (
        <SelectionInfo leftSlot={<PlaceText text='Allways' />} text={parsed.ALLWAYS} />
      )}

      {parsed['LEG-IN'] && (
        <SelectionInfo leftSlot={<PlaceText text='Leg-In' />} text={parsed['LEG-IN']} />
      )}

      {parsed.RB && <SelectionInfo leftSlot={<PlaceText text='RB' />} text={parsed.RB} />}

      {parsed.WITH && <SelectionInfo leftSlot={<PlaceText text='With' />} text={parsed.WITH} />}
    </Flex>
  )
}
